// CSS
import '../sass/pages/home.scss'

// === WP ALPHA ASSETS
import '@nematis/wp-alpha/assets/js/home'

// === COMPONENTS
import {
  initHorizontalAutoScroll
} from './components/horizontal-autoscroll'

// Auto-scroll lent du slider Chiffres clés sur mobile (aller-retour)
const initKeyFigures = () => {
  initHorizontalAutoScroll(document.querySelector('.key-figures .row'))
}

if (document.readyState !== 'loading') {
  initKeyFigures()
} else {
  document.addEventListener('DOMContentLoaded', initKeyFigures)
}
